import Header from "./Header";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Profile({ onProfileUpdated }) {
  const navigate = useNavigate();

  const [profile, setProfile] = useState({
    fname: "",
    lname: "",
    phone: "",
  });

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState("");

const user = JSON.parse(localStorage.getItem("user"));
const customerId = user?.id || user?.customer_id;

const fetchProfile = async () => {
  try {
    if (!customerId) {
      navigate("/login");
      return;
    }

    setLoading(true);

    const res = await fetch(
      "https://aethearia.store/superadmin/api/profile",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_id: Number(customerId),
        }),
      }
    );

    const data = await res.json();
    console.log("Profile API Response:", data);

    if (data.status) {
      const userData = Array.isArray(data.data)
        ? data.data[0]
        : data.data;

      setProfile({
        fname:
          userData?.fname ||
          userData?.first_name ||
          userData?.name ||
          "",
        lname:
          userData?.lname ||
          userData?.last_name ||
          "",
        phone:
          userData?.phone ||
          userData?.mobile ||
          "",
      });
    } else {
      setMessage(data.message || "Profile not found");
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const updateProfile = async (e) => {
    e.preventDefault();
     
    if (profile.phone.length !== 10) {
      setMessage("Please enter a valid 10 digit phone number");
      return;
    }

    try {
      setUpdating(true);
      setMessage("");

      const res = await fetch(
        "https://aethearia.store/superadmin/api/update-profile",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customer_id: Number(customerId),
            fname: profile.fname,
            lname: profile.lname,
            phone: profile.phone,
          }),
        }
      );

      const data = await res.json();
      console.log("Update Profile API:", data);

    if (data.status) {
      setMessage("Profile updated successfully");

      const oldUser = JSON.parse(localStorage.getItem("user") || "{}");

      const updatedUser = {
        ...oldUser,
        fname: profile.fname,
        lname: profile.lname,
        phone: profile.phone,
      };

      localStorage.setItem("user", JSON.stringify(updatedUser));

      setProfile({
        fname: profile.fname,
        lname: profile.lname,
        phone: profile.phone,
      });

      if (onProfileUpdated) {
        onProfileUpdated(updatedUser);
      }
    }else {
        setMessage(data.message || "Profile update failed");
      }
    } catch (err) {
      console.error("Update profile error:", err);
      setMessage("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <>
      <style>{`
        .profile-page{
          min-height:100vh;
          padding:0 20px 70px;
          color:#4c144e;
        }

        .profile-container{
          max-width:650px;
          margin:0 auto;
          // border:1px solid #4c144e;
          // padding:40px;
          border-radius:8px;
          background:transparent;
        }

        .profile-title{
          font-size:35px;
          font-weight:100;
          text-align:center;
          color:#4c144e;
        }

        .profile-form{
          display:flex;
          flex-direction:column;
          gap:22px;
        }

        .form-group{
          display:flex;
          flex-direction:column;
          gap:8px;
        }

        .form-group label{
          font-size:15px;
          color:#4c144e;
          font-weight:500;
        }

        .form-group input{
          height:48px;
          border:1px solid #4c144e;
          background:transparent;
          padding:0 14px;
          color:#4c144e;
          font-size:15px;
          outline:none;
          border-radius:5px;
        }

        .form-group input:focus{
          border-color:#111;
        }

        .profile-btn{
          height:48px;
          background:#4c144e;
          color:#fff;
          border:none;
          border-radius:5px;
          font-size:15px;
          cursor:pointer;
          margin-top:10px;
          transition:.3s;
        }

        .profile-btn:hover{
          background:#111;
        }

        .profile-btn:disabled{
          opacity:.6;
          cursor:not-allowed;
        }

        .profile-message{
          text-align:center;
          margin-top:18px;
          font-size:15px;
          color:#4c144e;
        }

        .loading-text{
          text-align:center;
          font-size:18px;
        }

        @media(max-width:768px){
          .profile-page{
            padding:0 15px 50px;
          }

          .profile-container{
            padding:25px 18px;
          }

          .profile-title{
            font-size:24px;
            margin-bottom:25px;
          }
        }
      `}</style>

      <section className="profile-page">
        <div className="profile-container">
          <h1 className="profile-title">My Profile</h1>

          {loading ? (
            <p className="loading-text">Loading profile...</p>
          ) : (
            <form className="profile-form" onSubmit={updateProfile}>
            <div className="form-group">
                  <label>First Name</label>
                  <input
                    type="text"
                    value={profile.fname}
                    onChange={(e) => {
                      const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");

                      setProfile({
                        ...profile,
                        fname: onlyLetters,
                      });
                    }}
                    placeholder="Enter first name"
                  />
                </div>

                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    value={profile.lname}
                    onChange={(e) => {
                      const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");

                      setProfile({
                        ...profile,
                        lname: onlyLetters,
                      });
                    }}
                    placeholder="Enter last name"
                  />
                </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength="10"
                  value={profile.phone}
                  onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(/\D/g, "");

                    setProfile({
                      ...profile,
                      phone: onlyNumbers,
                    });
                  }}
                  placeholder="Enter phone number"
                />
              </div>

              <button
                type="submit"
                className="profile-btn"
                disabled={updating}
              >
                {updating ? "Updating..." : "Update Profile"}
              </button>

              {message && (
                <p className="profile-message">
                  {message}
                </p>
              )}
            </form>
          )}
        </div>
      </section>

    </>
  );
}

export default Profile;